module.exports = __webpack_public_path__ + "static/ceremony-ig-1f78e6202e8595bdf2448531d2630fe4.mp4";